import React from 'react'
import { Spinner } from 'react-bootstrap'
import { connect } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { isValidToken } from '../Lib/constants'
import * as authActions from '../Services/Authentication/action'
import "../Assets/Css/Home.scss"
import { useEffect } from 'react'

const Home = (props) => {

    const navigate = useNavigate()

    const islogin = () => {
        console.log("check ran")
        const localUser = JSON.parse(localStorage.getItem('user'))
        if (localUser) {
            const response = isValidToken(localUser.exp)
            if (response) {
                return navigate('/dashboard')
            } else {
                props.refreshToken(localUser.refreshToken).then((response) => {
                    if (response.status === 200) {
                        localUser.accessToken = response.data.accessToken
                        localUser.exp = response.data.exp
                        console.log("Token refreshed successfully!")
                        localStorage.setItem('user', JSON.stringify(localUser))
                        return navigate('/dashboard')
                    } else {
                        localStorage.removeItem('user')
                        return navigate('/login')
                    }
                }).catch((e) => { console.log("error", e); return navigate('/login') })
            }
        }else{
            navigate('/login')
        }

    }

    useEffect(() => {
        islogin()
    }, [])

    return (
        <div className='home-main' >
            <Spinner animation='grow' />
        </div>
    )
}

const mapStateToProps = () => {
    return {}
}

const mapDispatchToProps = {
    refreshToken: authActions.refreshToken
}

export default connect(mapStateToProps, mapDispatchToProps)(Home)